<div class="login relative" @routeParent>
  <div
    #routerPane
    class="content-group no-padding router-container"
    [@routeAnimations]="{
      value: getRouteAnimationData(),
      params: {
        startHeight: routerHeight,
      },
    }"
    (@routeAnimations.done)="animationDone()"
  >
    <section class="header">
      <img src="/assets/img/logo/ico-sq-hq.png" alt="logo" />
      <div class="header-text">
        <h2>{{ header().title }}</h2>
        <p>{{ header().subtitle }}</p>
      </div>
    </section>
    <div class="content-group-padding">
      <router-outlet></router-outlet>
    </div>
    <div class="footer-padding"></div>
    <section class="footer">
      <div class="footer-links">
        @for (fl of footerLinks; track fl.url) {
          <a [routerLink]="fl.url" [routerLinkActive]="'active'">{{
            fl.text
          }}</a>
        }
      </div>
    </section>
  </div>
</div>
<fini-login-footer></fini-login-footer>
<fini-login-mosaic></fini-login-mosaic>
<fini-login-splashscreen [authcheck]="authcheck()"></fini-login-splashscreen>
